<template>

    <li class="module" data-indicate="pagecontent">
        <a href="#submenu2" data-bs-toggle="collapse" class="nav-link px-0 align-middle linkmodule">
            <i class="fs-4 bi-speedometer2"></i> <span class="ms-3 d-none d-sm-inline">Page Content</span></a>
        <ul class="collapse nav flex-column justify-content-center align-items-center ms-1 submenu_lateral" id="submenu2" data-bs-parent="#submenu_website">

            <template v-if="pageContentComputed.length > 0">
            
                <li v-for="(value, index) in pageContentComputed" :key="index" class="w-100 text-start">
                    <a 
                        :href="pagescontentlink + pagesshowlink + value.id" 
                        target="_self"
                        class="nav-link px-0 ps-5"  
                        aria-describedby="Pages Link"
                        aria-current="page"
                    >{{ value.title }}</a>
                </li>

            </template>

           
            <template v-else>

                <li class="list-group-item">Please create Pages</li>

            </template>
        </ul>
    </li>

</template>
<script>

    import store from '../../store/index.js';


    export default{
        name: 'PageContentNavElement',
        props:{
            contentpagesubmenu:{
                type: String,
                required: true
            },
            logout:{
                type: String,
                required: true
            },
            pagescontentlink:{
                type: String,
                required: true
            }

        },
        data: () => {

            return{

                navpagecontent: [],
                pagesshowlink: '/admin/website/pagescontent/'

            }

        },
        created(){

            //Set Page Content Li
            this.navpagecontent = JSON.parse(this.contentpagesubmenu);

           /*  console.log(this.navpagecontent);
            console.log(store.state.pageslist);
            console.log(this.pageContentComputed); */


        },
        methods:{

            showSubMenu(){

                //Check SubMenu
                if(!document.querySelector('.pageslistcontents').classList.contains('active')){

                document.querySelector('.pageslistcontents').classList.add('active');

                }else{

                document.querySelector('.pageslistcontents').classList.remove('active');

                }

            },
            findpage(navpagecontent, typeofpage){

                //Clean Data
                let page = navpagecontent.find((value, index) => {

                    if(value.hasOwnProperty('type')){

                        if(Object.is(value.type, typeofpage)){

                            return value;

                        }

                    }

                }); 

                //Get Variable
                if(page !== undefined){

                    //Get Index
                    let index = navpagecontent.indexOf(page);

                    navpagecontent.splice(index, 1);

                }

                return navpagecontent;

            }

        },
        computed:{

            pageContentComputed(){

                this.navpagecontent = JSON.stringify(store.state.pageslist).length > this.contentpagesubmenu.length ? store.state.pageslist : JSON.parse(this.contentpagesubmenu);

                //Clean Data
                this.navpagecontent = this.findpage(this.navpagecontent, 'underconstruction');
                this.navpagecontent = this.findpage(this.navpagecontent, 'preview');

                return this.navpagecontent;

            }

        },
        watch:{

            pageContentComputed(){

                return this.navpagecontent;

            }

        }


    }

</script>